























































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import ReservaSalaStore from '@/components/ReservaSala/Store/ReservaSalaStore'
import SolicitacaoCancelamentoStore from '@/components/SolicitacaoCancelamento/Store/SolicitacaoCancelamentoStore'
import { onlyNumber, humanTime, minutesToHours, getWeekdayByDate } from '@/utils/common'

// FullCalendar - TOdas as dependências...
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
import timeGrid from '@fullcalendar/timegrid'
import ptBrLocale from '@fullcalendar/core/locales/pt-br'
import moment from 'moment'
import { PrecaucoesFromTasyTipoEnum, PrecaucoesFromTasy } from '@/types/_'
import { ITriagem, Triagem } from '@/types/implements/Triagem'
import EventBus from '@/plugins/EventBus'
import tippy from 'tippy.js'

@Component({ components: { FullCalendar } })

export default class ComponentBackofficeConfirmarReservaSala extends Vue {
  $refs!: {
    confirmarTriagemRule: any,
  }

  calLoading: boolean = false
  loadEquipamentos: boolean = false
  loadCaixasCirurgicas: boolean = false
  preferredDate = [true]

  get calendarLoading() {
    return this.calLoading
  }

  set calendarLoading(val: boolean) {
    this.calLoading = val
  }

  triagem: ITriagem = new Triagem()

  calendarOptions: any = {
    timeZone: 'UTC',
    height: 350,
    locale: ptBrLocale,
    plugins: [resourceTimelinePlugin, interactionPlugin, dayGridPlugin, timeGrid],
    initialView: 'resourceTimeline',
    aspectRatio: 1.5,
    headerToolbar: {
      left: 'today,prev,next',
      center: 'title',
      right: '',
    },
    slotLabelFormat: { hour12: false, hour: '2-digit', minute: '2-digit' },
    slotDuration: '00:30:00',
    editable: false,
    droppable: false,
    selectable: true,
    resourceAreaHeaderContent: 'Salas',
    resourceOrder: 'title',
    resources: this.getReservaSalasResources,
    eventDidMount: this.eventRender,
    customButtons: {
      prev: {
        text: 'Anterior',
        click: async () => {
          const { calendar }: any = this.$refs
          const dateCurrent = moment(calendar.getApi().getDate()).format('YYYY-MM-DD')
          await this.changeDateResource(dateCurrent)
          calendar.getApi().prev()
        },
      },
      next: {
        text: 'Próximo',
        click: async () => {
          const { calendar }: any = this.$refs
          calendar.getApi().next()
          const dateCurrent = moment(calendar.getApi().getDate()).add('day', 1).format('YYYY-MM-DD')
          await this.changeDateResource(dateCurrent)
        },
      },
      today: {
        text: 'Hoje',
        click: () => {
          const { calendar }: any = this.$refs
          calendar.getApi().today()
          const dateCurrent = moment().format('YYYY-MM-DD')
          this.changeDateResource(dateCurrent)
        },
      },
    },
  }

  get showModalReservaSala() {
    return this.getReservaSalaStore.modalReservaSala
  }

  set showModalReservaSala(value: boolean) {
    this.getReservaSalaStore.setShowModalReservaSala(value)
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getSolicitacaoCancelamentoStore() {
    return getModule(SolicitacaoCancelamentoStore, this.$store)
  }

  get loadingEquipamentos() {
    return this.loadEquipamentos
  }

  set loadingEquipamentos(value: boolean) {
    this.loadEquipamentos = value
  }

  get loadingCaixasCirurgicas() {
    return this.loadCaixasCirurgicas
  }

  set loadingCaixasCirurgicas(value: boolean) {
    this.loadCaixasCirurgicas = value
  }

  campoHabilitado(prop: string) {
    if (this.getBackofficeGlobalStore.template.formulario) {
      const response = this.getBackofficeGlobalStore.template.formulario[prop]

      if (response) return !!response.habilitado
    }

    return false
  }

  canEditNumeroLeito() {
    return this.getBackofficeGlobalStore.acoes.permiteEditarLeitoDoPaciente
  }

  canEditNumeroAtendimento() {
    return this.getBackofficeGlobalStore.acoes.permiteEditarNumeroDoAtendimentoAoPacienteNoHospital
  }

  get doctorDeadlineJustification() {
    const { justificativaDePrazo: doctorDeadlineJustification } = this.getBackofficeGlobalStore.solicitacao

    return doctorDeadlineJustification
  }

  get surgeryWeekday() {
    return this.dateStart ? getWeekdayByDate(this.dateStart) : ''
  }

  get surgerySuggestedDate() {
    const { healthInsuranceData } = this.getBackofficeGlobalStore
    const sundayIndexWeekDay = 0
    let surgerySuggestedDateObject
    let surgerySuggestedDate

    const {
      prazoEmDiasParaSolicitarCirurgiaComOpme: suggestedSurgeryDateDaysWithOPME,
      prazoEmDiasParaSolicitarCirurgiaSemOpme: suggestedSurgeryDateDaysWithoutOPME,
    } = healthInsuranceData

    if (suggestedSurgeryDateDaysWithOPME && suggestedSurgeryDateDaysWithoutOPME) {
      if (this.surgeryHasOPME) {
        surgerySuggestedDateObject = moment().add(suggestedSurgeryDateDaysWithOPME, 'days')
      } else {
        surgerySuggestedDateObject = moment().add(suggestedSurgeryDateDaysWithoutOPME, 'days')
      }

      surgerySuggestedDate = surgerySuggestedDateObject

      if (surgerySuggestedDateObject.day() === sundayIndexWeekDay) {
        surgerySuggestedDate = surgerySuggestedDate.add(1, 'days')
      }


      return surgerySuggestedDate.format('DD/MM/YYYY')
    }

    return null
  }

  get surgeryHasOPME() {
    return this.getBackofficeGlobalStore.solicitacao.temOpme
  }

  async showModalEquipamentos() {
    this.loadingEquipamentos = true

    let hospitalId
    const { hospitalId: surgerySolicitationHospitalId } = this.getBackofficeGlobalStore.solicitacao

    if (this.getReservaSalaStore.hospitaisRede.length > 0) {
      const { data } = this.hospitalSelecionado
      const { id: hospitalIdFromNetwork } = data

      if (surgerySolicitationHospitalId === hospitalIdFromNetwork) {
        hospitalId = surgerySolicitationHospitalId
      } else {
        hospitalId = hospitalIdFromNetwork
      }
    } else {
      hospitalId = surgerySolicitationHospitalId
    }


    const loadEquipmentRequest = await this.getBackofficeGlobalStore.loadEquipamentos()

    if (loadEquipmentRequest.success) {
      await this.getBackofficeGlobalStore.getEquipmentGroupByHospitalId({ hospitalId })
    }

    this.getBackofficeGlobalStore.removeDuplicates()
    this.getBackofficeGlobalStore.setModal({ name: 'equipamentos', value: true })
    this.loadingEquipamentos = false
  }

  async showModalCaixasCirurgicas() {
    this.loadingCaixasCirurgicas = true
    await this.getBackofficeGlobalStore.getAllCaixasCirurgicasByHospitalId()
    this.getBackofficeGlobalStore.setModal({ name: 'caixaCirurgica', value: true })
    this.loadingCaixasCirurgicas = false
  }

  eventRender(info: any) {
    if (info.event.extendedProps.dataAgendamentoVirtual) {
      const span = document.createElement('span')
      span.setAttribute('class', 'fa fa-building white--text ml-2')
      info.el.appendChild(span)
    }

    // Tooltip for each created event
    // If has description in event
    if (info.event.extendedProps.description) {
      tippy(info.el, {
        content: info.event.extendedProps.description,
        placement: 'top',
      })
    }
  }

  confirmarTriagemRule: any = {
    valid: true,
    numeroReserva: [
      v => !!v || 'O campo n reserva é obrigatório.',
    ],
    surgeryCenterRules: [
      v => (this.canShowSurgeryCenterReservation ? ((!!v && !!v.id) || 'O campo Centro Cirúrgico é obrigatório.') : true),
    ],
    surgeryCenterSalaRules: [
      v => (this.canShowSurgeryCenterReservation ? ((!!v && !!v.id) || this.getReservaSalaStore.reservaSalaInfo.dataAgendamentoVirtual || 'O campo sala da cirurgia é obrigatório.') : true),
    ],
    salaRules: [
      v => (!this.canShowSurgeryCenterReservation ? (!!v && !!v.id) || 'O campo sala da cirurgia é obrigatório.' : true),
    ],
    dateStartRules: [
      v => !!v || 'O campo data da cirurgia é obrigatório.',
    ],
    timeStartRules: [
      v => !!v || 'O campo data da cirurgia é obrigatório.',
      v => this.validaTimeStart(v) || 'O campo data da cirurgia é obrigatório.',
    ],
    timerSurgeryRules: [
      v => !!v || 'O campo tempo da cirurgia é obrigatório.',
    ],
    intervalRoomRules: [
      v => !!v || 'O campo intervalo pós-cirurgia é obrigatório.',
    ],
  }

  dtStart: string = ''
  get dateStart() { return this.dtStart }
  set dateStart(value) { this.dtStart = value }

  timezone: string = ''
  timeStart: string = ''
  event: any = {}
  loaderNumeroReserva: boolean = false
  loadConfirmar: boolean = false
  currentDate: any = moment('2021-02-03', 'YYYY-MM-DD').format('YYYY-MM-DD')
  numeroReservaMessage: string = ''
  opcoesDeDataInformadasPeloMedico: string = ''

  get roomChecked() {
    return this.getReservaSalaStore.roomChecked
  }

  get hospitalSelecionado() {
    return this.getReservaSalaStore.hospitalSelecionado
  }

  get surgeryCenter() {
    return this.getReservaSalaStore.surgeryCenter
  }

  get getCurrentDate() {
    return this.currentDate
  }

  set getCurrentDate(value) {
    this.currentDate = value
  }

  get getReservaSalaStore() {
    return getModule(ReservaSalaStore, this.$store)
  }

  get getReservaSalasResources() {
    return this.getReservaSalaStore.reservaSalasResource
  }

  get getReservaSalasEvents() {
    return this.getReservaSalaStore.reservaSalasEvent
  }

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get loadingNumeroReserva() {
    return this.loaderNumeroReserva
  }

  set loadingNumeroReserva(value: boolean) {
    this.loaderNumeroReserva = value
  }

  validaTimeStart(value) {
    if (value) return true
    return false
  }

  getDatasPrevistas() {
    const datas = [
      this.getReservaSalaStore.reservaSalaInfo.opcaoDataPrevisto1,
      this.getReservaSalaStore.reservaSalaInfo.opcaoDataPrevisto2,
      this.getReservaSalaStore.reservaSalaInfo.opcaoDataPrevisto3,
    ]
    return datas.filter(e => !['', null, undefined].includes(e)).map(e => humanTime(e)).join(', ')
  }

  async changeRoom() {
    if (this.$refs.confirmarTriagemRule) EventBus.$emit('disabledConfirmarTriagem', !this.$refs.confirmarTriagemRule.validate())
  }

  async changeTime() {
    if (this.$refs.confirmarTriagemRule) EventBus.$emit('disabledConfirmarTriagem', !this.$refs.confirmarTriagemRule.validate())
  }

  async changeDateFullCalendar() {
    // Check can't send request withou parameters
    if (
      !this.validadeDateStart()
      || !this.getBackofficeGlobalStore.solicitacao.tempoCirurgia
      || !this.getBackofficeGlobalStore.solicitacao.id
    ) {
      return
    }

    this.calendarLoading = true
    const dateChange = moment(this.dateStart).format('YYYY-MM-DD')
    const params = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      data: dateChange,
      hora: this.timeStart || null,
      tempoCirurgia: this.getBackofficeGlobalStore.solicitacao.tempoCirurgia,
    }

    const { calendar }: any = this.$refs
    await calendar.getApi().removeAllEvents()

    const res = await this.getReservaSalaStore.getReservaSalas(params)
    if (res.success) {
      await calendar.getApi().addEventSource(this.getReservaSalaStore.reservaSalasEvent)
      calendar.getApi().gotoDate(dateChange)
      calendar.getApi().render()

      if (this.$refs.confirmarTriagemRule) EventBus.$emit('disabledConfirmarTriagem', !this.$refs.confirmarTriagemRule.validate())
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: res.message || 'Ocorreu um erro ao buscar as reservas.', icon: 'warning', color: '#C62828' })
    }

    this.calendarLoading = false
  }

  validadeDateStart() {
    if (!this.dateStart) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Data da cirurgia é obrigatório', icon: 'warning', color: '#C62828' })
      return false
    }

    const selectedYear = Number(moment(this.dateStart).format('YYYY'))

    if (selectedYear < 2018) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não existem agendamentos anteriores a 2018', icon: 'warning', color: '#C62828' })
      this.dateStart = ''
      return false
    }

    if (selectedYear > 9999) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Data inválida', icon: 'warning', color: '#C62828' })
      this.dateStart = ''
      return false
    }

    return true
  }

  async loadReservaDeSala() {
    this.calendarLoading = true
    const { dataAgendamento, opcaoDataPrevisto1 } = this.getBackofficeGlobalStore.novaDataSolicitada

    let dataAgendament = ''

    if (!['', null, undefined].includes(dataAgendamento)) {
      // @ts-ignore
      dataAgendament = moment(this.getBackofficeGlobalStore.novaDataSolicitada.dataAgendamento)
    } else if (!['', null, undefined].includes(opcaoDataPrevisto1)) {
      // @ts-ignore
      dataAgendament = moment(this.getBackofficeGlobalStore.novaDataSolicitada.opcaoDataPrevisto1)
    } else {
      // @ts-ignore
      dataAgendament = moment()
    }

    this.dateStart = moment(dataAgendament).format('YYYY-MM-DD')

    if (this.getBackofficeGlobalStore.novaDataSolicitada.dataAgendamento) {
      this.timeStart = moment(dataAgendament).format('HH:mm')
    }

    const params = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      data: this.dateStart,
      hora: this.timeStart,
      tempoCirurgia: this.getBackofficeGlobalStore.solicitacao.tempoCirurgia,
      hospitalId: this.hospitalSelecionado ? this.hospitalSelecionado.data.id : null,
    }

    const { calendar }: any = this.$refs
    await calendar.getApi().removeAllEvents()

    const res = await this.getReservaSalaStore.getReservaSalas(params)
    if (res.success) {
      this.dateStart = moment(this.getReservaSalaStore.reservaSalaInfo.dataAgendamento).format('YYYY-MM-DD')

      await calendar.getApi().removeAllEvents()
      await calendar.getApi().addEventSource(this.getReservaSalaStore.reservaSalasEvent)
      await calendar.getApi().render()
      await calendar.getApi().gotoDate(this.dateStart)
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: res.message || 'Ocorreu um erro ao buscar as reservas.', icon: 'warning', color: '#C62828' })
    }

    if (this.$refs.confirmarTriagemRule) EventBus.$emit('disabledConfirmarTriagem', !this.$refs.confirmarTriagemRule.validate())

    this.calendarLoading = false
  }

  async changeDateResource(value: string) {
    // Check can't send request withou parameters
    if (
      !this.validadeDateStart()
      || !this.getBackofficeGlobalStore.solicitacao.tempoCirurgia
      || !this.getBackofficeGlobalStore.solicitacao.id
    ) {
      return
    }

    this.calendarLoading = true

    this.dateStart = moment(value).format('YYYY-MM-DD')

    const params = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      data: this.dateStart,
      tempoCirurgia: this.getBackofficeGlobalStore.solicitacao.tempoCirurgia,
    }
    const { calendar }: any = this.$refs
    await calendar.getApi().removeAllEvents()

    const res = await this.getReservaSalaStore.getReservaSalas(params)
    if (res.success) {
      calendar.getApi().removeAllEvents()
      await calendar.getApi().addEventSource(this.getReservaSalaStore.reservaSalasEvent)
      calendar.getApi().render()
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: res.message || 'Ocorreu um erro ao buscar as reservas.', icon: 'warning', color: '#C62828' })
    }

    if (this.$refs.confirmarTriagemRule) EventBus.$emit('disabledConfirmarTriagem', !this.$refs.confirmarTriagemRule.validate())

    this.calendarLoading = false
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  minutesToHoursUtil(value) {
    return minutesToHours(value)
  }

  async checkNumeroReserva(numeroReserva: string = this.getReservaSalaStore.reservaSalaInfo.numeroAgendamento) {
    this.loadingNumeroReserva = true
    if (numeroReserva) {
      const params: any = {
        solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
        numeroReserva,
        hospitalId: this.getBackofficeGlobalStore.solicitacao.hospitalId,
      }

      const response = await this.triagem.getCheckNumeroReserva(params)
      this.loadingNumeroReserva = false
      if (!response.success) {
        this.numeroReservaMessage = ''
        EventBus.$emit('setSnackbar', { show: true, text: 'Houve um erro na validação no número de reserva.', icon: 'warning', color: '#C62828' })
        return false
      }

      if (response.success && response.data) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Número de reserva duplicado.', icon: 'warning', color: '#C62828' })
        this.numeroReservaMessage = 'Número de reserva duplicado.'
        return false
      }

      this.numeroReservaMessage = ''
      return true
    }

    this.numeroReservaMessage = 'O campo número de reserva é obrigatório.'
    this.loadingNumeroReserva = false
    return false
  }

  modalReset() {
    this.$refs.confirmarTriagemRule.reset()
    this.getReservaSalaStore.clearReservaSalasResource()
    this.getReservaSalaStore.clearReservaSalaEvent()
    this.getReservaSalaStore.clearSurgeryCenter()
    this.getReservaSalaStore.clearRoomChecked()
    this.getReservaSalaStore.clearCentrosCirurgicos()
    this.getReservaSalaStore.setShowModalReservaSala(false)
    this.numeroReservaMessage = ''
  }

  get precaucoesFromTasyAlergias() {
    const { precaucoesFromTasy } = this.getReservaSalaStore
    return precaucoesFromTasy && precaucoesFromTasy.length > 0
      ? precaucoesFromTasy.filter((obj: PrecaucoesFromTasy) => obj.tipo === PrecaucoesFromTasyTipoEnum.ALERGIA)
      : []
  }

  get precaucoesFromTasyPrecaucoes() {
    const { precaucoesFromTasy } = this.getReservaSalaStore
    return precaucoesFromTasy && precaucoesFromTasy.length > 0
      ? precaucoesFromTasy.filter((obj: PrecaucoesFromTasy) => obj.tipo === PrecaucoesFromTasyTipoEnum.PRECAUCAO)
      : []
  }

  async renderCalendarEvents() {
    if (this.dateStart) {
      const { calendar }: any = this.$refs
      await calendar.getApi().removeAllEvents()
      await calendar.getApi().addEventSource(this.getReservaSalaStore.reservaSalasEvent)
      await calendar.getApi().gotoDate(this.dateStart)
      await calendar.getApi().render()
    }
  }

  async virtualDateChange() {
    if (this.canShowSurgeryCenterReservation) {
      await this.getReservaSalaStore.clearRoomChecked()
      await this.getReservaSalaStore.updateReservaSalaResource()
      await this.renderCalendarEvents()
    }
    if (this.$refs.confirmarTriagemRule) EventBus.$emit('disabledConfirmarTriagem', !this.$refs.confirmarTriagemRule.validate())
  }

  changeHospital() {
    this.getReservaSalaStore.clearCentrosCirurgicos()
    this.getReservaSalaStore.clearSurgeryCenter()
    this.getReservaSalaStore.clearRoomChecked()

    this.equipmentSelectionConfirmed = false
    this.loadReservaDeSala()
  }

  async surgeryCenterChange() {
    await this.getReservaSalaStore.clearRoomChecked()
    await this.getReservaSalaStore.updateReservaSalaResource()
    if (this.$refs.confirmarTriagemRule) EventBus.$emit('disabledConfirmarTriagem', !this.$refs.confirmarTriagemRule.validate())
  }

  get equipmentSelectionConfirmed() {
    return this.getBackofficeGlobalStore.equipmentSelectionConfirmed
  }

  set equipmentSelectionConfirmed(confirmed: boolean) {
    this.getBackofficeGlobalStore.setEquipmentSelectionConfirmation(confirmed)
  }

  get canShowSurgeryCenterReservation() {
    return this.getReservaSalaStore.centrosCirurgicos.length > 0
  }

  get canSurgeryCenterShowRoomField() {
    return this.getReservaSalaStore.configuracoes.dataVirtualFazReservaDeSala || !this.getReservaSalaStore.reservaSalaInfo.dataAgendamentoVirtual
  }

  get canShowGridTime() {
    return this.getReservaSalaStore.configuracoes.dataVirtualFazReservaDeSala || !this.getReservaSalaStore.reservaSalaInfo.dataAgendamentoVirtual
  }

  get getDisplayPreReserva() {
    return !this.getReservaSalaStore.configuracoes.dataVirtualFazReservaDeSala && this.getReservaSalaStore.reservaSalaInfo.dataAgendamentoVirtual
  }
}
